import { createContext } from "react";

export interface IUserContext {
  name: string;
  userName: string;
  email: string;
  role: string;
  region?: string;
  type: "INTERNAL" | "EXTERNAL";
  restriction?: string;
  id: string;
  employeeId: string;
  isImpersonate: boolean;
  impersonateUserEmail?: string;
  impersonateUserRole?: string;
  impersonateUserRegion?: string;
  impersonateUserType?: "INTERNAL" | "EXTERNAL";
  impersonateUserDataRestriction?: string;
  impersonateId?: string;
  impersonateUserOriginalEmployeeId?: string;
}

export interface ITokenContext {
  token: string;
}

export interface jwtContext {
  displayName: string;
  accountName: string;
  email: string;
  id: string;
  employeeId: string;
  originalEmployeeId: string;
  userRole: string;
  userRegion: string;
  userType: "INTERNAL" | "EXTERNAL";
  userDataRestriction: string;
  isImpersonate: boolean;
  impersonateUserEmail?: string;
  impersonateUserRole?: string;
  impersonateUserRegion?: string;
  impersonateUserType?: "INTERNAL" | "EXTERNAL";
  impersonateUserDataRestriction?: string;
  impersonateId?: string;
  impersonateUserOriginalEmployeeId?: string;
}

export const UserContext = createContext<{
  value: IUserContext | null;
  set: ((a: IUserContext) => void);
}>({ value: null, set: () => {} });

export interface IAppContext {
  dtaUrl: string;
}

export const defaultContext = {
  dtaUrl: ''
}

export const AppContext = createContext<{
  value: IAppContext ;
  set: ((a: IAppContext) => void);
}>({ value: defaultContext, set: () => {} });
